module.exports = __webpack_public_path__ + "static/media/confirmacion__festejaOXXOSPEI.40ca264e.svg";